// @catalog F.006
// CompositionRow — fila label + valor + % + progress bar.
// Usado en card "Composición del mes" de /ventas.
import { Box } from "@mui/material";

interface CompositionRowProps {
  label: string;
  value: number;
  total: number;
  color?: string;
  // inverse=true representa un descuento o erosión (valor que reduce, no aporta).
  inverse?: boolean;
  formatValue: (v: number) => string;
}

export function CompositionRow(props: CompositionRowProps): JSX.Element {
  const {
    label,
    value,
    total,
    color = "var(--accent)",
    inverse = false,
    formatValue,
  } = props;

  const pct = total > 0 ? (value / total) * 100 : 0;
  const valueColor = inverse ? "var(--neg)" : "var(--ink-1)";

  return (
    <Box sx={{ marginBottom: "14px" }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "6px",
        }}
      >
        <Box component="span" sx={{ fontSize: "13px", fontWeight: 500, color: "var(--ink-1)" }}>
          {label}
        </Box>
        <Box
          component="span"
          sx={{
            fontSize: "13px",
            color: valueColor,
            fontVariantNumeric: "tabular-nums",
          }}
        >
          {inverse ? "−" : ""}
          {formatValue(value)}
          <Box
            component="span"
            sx={{ color: "var(--ink-3)", marginLeft: "6px", fontSize: "12px" }}
          >
            {pct.toFixed(1)}%
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          height: "6px",
          backgroundColor: "var(--bg-2)",
          borderRadius: "3px",
          overflow: "hidden",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: `${Math.min(100, Math.max(0, pct))}%`,
            backgroundColor: color,
            borderRadius: "3px",
            transition: "width 0.2s ease",
          }}
        />
      </Box>
    </Box>
  );
}
